import { useLogHomeHealthCasesListViewed } from "../../lib/useLogHomeHealthPageViewed";
import { useAgencyCases } from "../api/useAgencyCases";
import { CaseSort, CaseStatus } from "../types";
import { MobileCasesListView } from "./MobileCasesListView";

export function MobileCasesListContainer() {
  useLogHomeHealthCasesListViewed();

  const {
    data: cases = [],
    isLoading,
    isError,
    refetch,
  } = useAgencyCases({
    filter: { status: CaseStatus.OPEN },
    sort: CaseSort.CREATED_AT_DESC,
  });

  return (
    <MobileCasesListView
      cases={cases}
      isLoading={isLoading}
      isError={isError}
      onRefresh={refetch}
    />
  );
}
